import { Close } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Stack,
  Typography,
} from "@mui/material";

import { useListTechCommunitiesQuery } from "api/public/techCommunities/techCommunities.api";

interface BecomeInternationalTcFormProps {
  show: boolean;
  setShowModal: (_show: boolean) => void;
}

export default function BecomeInternationalTcForm({
  show,
  setShowModal,
}: BecomeInternationalTcFormProps) {
  const { data: communities = [], isLoading } = useListTechCommunitiesQuery({
    isInternational: true,
  });

  const handleClose = () => setShowModal(false);

  return (
    <Dialog open={show} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h5" color="primary">
            BECOME AN INTERNATIONAL TC PARTICIPANT
          </Typography>
          <IconButton onClick={handleClose} size="small">
            <Close />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Select an International Technical Community below and be redirected to
          the Common Criteria Website
        </Typography>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: 2,
              px: 2,
              pb: 3,
            }}
          >
            {communities.map((itc) => (
              <Link
                key={itc.community_id}
                href={itc.url ?? undefined}
                rel="noreferrer"
                target="_blank"
              >
                {itc.community_name}
              </Link>
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
